import { buildResourcesByCategory } from './honest-jobs-widget.util';
import { mapWidget } from './case-plan-widget.util';

const DEFAULT_LEARNER_NAME = '-';

const buildPersonName = (person) => {
  const firstName = person.firstName ? person.firstName : '';
  const lastName = person.lastName ? person.lastName : '';
  return `${firstName} ${lastName}`.trim();
};

const resolveLearnerDisplayName = (name, planName) => {
  if (name) {
    return name;
  }
  return planName ? planName : DEFAULT_LEARNER_NAME;
};

const formatLearnerName = (person, planName) => {
  if (!person) {
    return resolveLearnerDisplayName('', planName);
  }

  return resolveLearnerDisplayName(buildPersonName(person), planName);
};

export const mapDetailCardProps = (plan) => {
  const person = plan?.person;

  return {
    learnerName: formatLearnerName(person, plan?.name),
    username: person?.username ?? '',
    docId: person?.docId ?? plan?.docId ?? '',
    location: person?.location?.locationName ?? '',
    showBackButton: true,
  };
};

/** Maps API sections into UI props, preserving backend sort order. */
export const mapSections = (sections = [], resourcesByCategory = {}) =>
  sections.map((section) => ({
    id: section.id,
    title: section.name ?? '',
    description: section.description ?? '',
    visibleToLearner: section.visibleToLearner ?? true,
    widgets: (section.widgets ?? []).map((widget) =>
      mapWidget(widget, resourcesByCategory),
    ),
  }));

export const mapCasePlanDetailResponse = (response, reentryPlan = null) => {
  const resourcesByCategory = buildResourcesByCategory(reentryPlan);

  return {
    cardProps: mapDetailCardProps(response?.plan),
    sections: mapSections(response?.sections, resourcesByCategory),
  };
};
